import RootElementsBehavior from './RootElementsBehavior';

export default {
  __init__: [ 'rootElementsBehavior' ],
  rootElementsBehavior: [ 'type', RootElementsBehavior ]
};
